import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { headersFaq, fieldObjectFaq as fieldObject } from './auxiliarFaq';
import { valoresExibidosFaq } from './auxiliarFaq';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useTopicoComunicacao } from '../../../../services/enum/useTopicoComunicacao';
import { getAllFaqs } from '../../../../services/fornecedoresDAF/faqService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import SubAbas from '../subabas';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Faq;

const FaqIndex: React.FC = () => {
  const navigate = useNavigate();
  const topicoComunicacao = useTopicoComunicacao();

  const [formFiltros, setFormFiltros] = useState({
    topicoComunicacao: 0,
    outroTopico: '',
    contexto: '',
    respostaEncaminhamento: '',
  });

  const [data, setData] = useState<any[]>([]);
  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllFaqs();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const tableData = data
    .map((item) => ({
      id: item.id,
      topicoComunicacao:
        item.topicoComunicacao === 6
          ? item.outroTopico
          : topicoComunicacao[item.topicoComunicacao].label,
      contexto: item.contexto,
      respostaEncaminhamento: item.respostaEncaminhamento,
    }))
    .filter((item: any) => {
      return (
        (formFiltros.topicoComunicacao === 0 ||
          item.topicoComunicacao ===
            topicoComunicacao[formFiltros.topicoComunicacao].label) &&
        (formFiltros.contexto === '' ||
          item.contexto
            .toLowerCase()
            .includes(formFiltros.contexto.toLowerCase())) &&
        (formFiltros.respostaEncaminhamento === '' ||
          item.respostaEncaminhamento
            .toLowerCase()
            .includes(formFiltros.respostaEncaminhamento.toLowerCase()))
      );
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    topicoComunicacao:
      item.topicoComunicacao === 6 ? (
        <b>{item.outroTopico}</b>
      ) : (
        <b>{topicoComunicacao[item.topicoComunicacao].label}</b>
      ),
    contexto: item.contexto,
    respostaEncaminhamento: item.respostaEncaminhamento,
    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  // Funções Handle
  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      topicoComunicacao: 0,
      outroTopico: '',
      contexto: '',
      respostaEncaminhamento: '',
    });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'topicoComunicacao') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        topicoComunicacao: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="25%">
              <Select
                name="topicoComunicacao"
                value={formFiltros.topicoComunicacao}
                options={topicoComunicacao}
                onChange={handleChange}
                label="Tópico de Comunicação"
              />
            </CustomCol>

            <CustomCol>
              <Input
                id="contexto"
                name="contexto"
                value={formFiltros.contexto}
                label="Contexto"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                id="respostaEncaminhamento"
                name="respostaEncaminhamento"
                value={formFiltros.respostaEncaminhamento}
                label="Resposta/Encaminhamento"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080"
                textColor="#ffffff"
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersFaq}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosFaq}
          tituloCanvas="FAQ"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          //  downloadDisabled={!canDownload}
          onClickDownload={() =>
            ExportToExcel(
              data,
              valoresExibidosFaq,
              fieldObject,
              'faqs.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade)
            )
          }
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default FaqIndex;
